import { Color } from '@billy/design-system'
import { Text, View } from '@react-pdf/renderer'
import { useMemo } from 'react'

import { getFormattedBalance } from '@features/reports/elements/BalanceCell/utils/getFormattedBalance'
import { ReportRowType } from '@features/reports/types/reportRowType'

import { columnPdfStyles } from '../../../../utils/columnPdfStyles'
import { balanceCellStyles } from './utils/balanceCellStyles'

interface ReportsPdfBalanceCellProps {
  balance: number
  columnKey?: string
  rowType: ReportRowType
}

export const ReportsPdfTableBalanceCell = ({ balance, columnKey, rowType }: ReportsPdfBalanceCellProps) => {
  const isBalanceTypeRelative = columnKey === 'percentageChange' || columnKey === 'percentageOfType'

  const isHeaderOrFooter = rowType === ReportRowType.Header || rowType === ReportRowType.Footer
  const color = isHeaderOrFooter ? Color.White : Color.Black
  const isBold = isHeaderOrFooter || rowType === ReportRowType.Group

  const balanceFormatted = useMemo(
    () => getFormattedBalance(balance || 0, isBalanceTypeRelative),
    [balance, isBalanceTypeRelative],
  )

  return (
    <View style={[columnPdfStyles.columnFluid, balanceCellStyles.cellContainer]}>
      <Text style={[balanceCellStyles.text, { color }, isBold ? balanceCellStyles.textBold : {}]}>
        {balanceFormatted}
      </Text>
    </View>
  )
}
